import { combineReducers } from '@reduxjs/toolkit';

import { resetOnLogoutReducer } from '@utils';

import {
  SAVE_AKELA_PROFILE_ERROR,
  SAVE_AKELA_PROFILE_REQUEST,
  SAVE_AKELA_PROFILE_RESPONSE,
  SAVE_PROFILE_ERROR,
  SAVE_PROFILE_REQUEST,
  SAVE_PROFILE_RESPONSE,
  SET_EDIT_PROFILE,
} from './actions';

const profileEditMode = (state = false, { type, payload }) => {
  switch (type) {
    case SET_EDIT_PROFILE: {
      return payload;
    }
    case SAVE_PROFILE_RESPONSE: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const profileSaveLoading = (state = false, { type }) => {
  switch (type) {
    case SAVE_PROFILE_REQUEST: {
      return true;
    }
    case SAVE_PROFILE_RESPONSE:
    case SAVE_PROFILE_ERROR: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const isSavingProfile = (state = false, { type }) => {
  switch (type) {
    case SAVE_AKELA_PROFILE_REQUEST: {
      return true;
    }
    case SAVE_AKELA_PROFILE_ERROR:
    case SAVE_AKELA_PROFILE_RESPONSE: {
      return false;
    }
    default: {
      return state;
    }
  }
};

const reducer = combineReducers({
  profileEditMode,
  profileSaveLoading,
  isSavingProfile,
});

export default resetOnLogoutReducer(reducer);
